import { RATE_BASED_RANGE_INPUT_LABELS } from '#app/components/DurationBudgetInputs/constants.js';
import { getInputTypeFromRateMin } from '#app/components/DurationBudgetInputs/utilities.js';
import { captureException } from '@contra/sentry/react';

export const getRateRangeFromMinHourlyRate = (minHourlyRate: number) => {
  const inputType = getInputTypeFromRateMin(minHourlyRate);
  if (!inputType) {
    captureException(
      `Unhandled user minimum hourly rate preference: ${minHourlyRate}`,
    );
    return null;
  }

  return RATE_BASED_RANGE_INPUT_LABELS[inputType];
};
